module.exports = __webpack_public_path__ + "img/gameanon.226d1c8d.svg";